import i18n from "./index";
import { SUPPORTED_LANGUAGES } from "./types";

export const getCurrentLanguage = () => i18n.language;

export const changeLanguage = (lng) => i18n.changeLanguage(lng);

/******************************************************************
 * ##: getStripeLocale
 * Maps checkout i18n language to Stripe Elements locale (pt | en).
 * @returns {string} Stripe locale code
 * History:
 * 30-05-2026: Created
 ******************************************************************/
export const getStripeLocale = () => {
  const lang = (i18n.language || "pt").split("-")[0].toLowerCase();
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : "pt";
};
